import {isLocalHost, makeid} from '../helpers/Helpers'
import jwtDecode from "jwt-decode";

export default {
  'version': "1.0.50",
  'name': process.env.APP_NAME,
  'api': {
    'endpoint': process.env.API_ENDPOINT,
    'cdn': process.env.CDN_ENDPOINT,
    getCdnEndPoint() {
      if (this.cdn) {
        return this.cdn
      } else {
        return this.endpoint;
      }
    },
    'csodOssoEnpoint': process.env.CSOD_OSSO_ENDPOINT ? process.env.CSOD_OSSO_ENDPOINT : "https://elucidbyelectrolux-stg.csod.com/outboundsso.aspx?ou_id=-5450",
    'endpointForImages': (process.env.API_ENDPOINT.indexOf("-live") > -1) ? "https://elucidbyelectrolux.csod.com" : "https://elucidbyelectrolux.csod.com",
  },
  'language': process.env.LANGUAGE,
  'prefix': 'csod-awave--',
  'adminURL': document.getElementById('application').getAttribute('data-admin-url'),
  'frontURL': document.getElementById('application').getAttribute('data-front-url') ? document.getElementById('application').getAttribute('data-front-url') : "https://elucidbyelectrolux-stg.csod.com/catalog/CustomPage.aspx?id=221000306",
  'client': document.getElementById('application').getAttribute('data-client'),
  'renderer': document.getElementById('application').getAttribute('data-renderer'),
  destroy(key) {
    localStorage.removeItem(this.getStoragePrefixes(key));
  },
  set(key, value) {
    localStorage.setItem(this.getStoragePrefixes(key), value);
  },
  get(key) {
    let value = null;
    value = localStorage.getItem(this.getStoragePrefixes(key));

    if (value === "true") {
      return true;
    }
    if (value === "null") {
      return null;
    }
    if (value === "false") {
      return null;
    }
    return value;
  },
  clearStorage() {
    this.destroy('apitoken');
    this.destroy('user');
    this.destroy('roleId');
    this.destroy('ssoId');
  },
  setToken(token) {
    this.set('apitoken', token);
  },
  getToken() {
    let token = this.get('apitoken');

    if (token) {
      let expDate = parseInt(jwtDecode(token).exp, 10) * 1000;
      let currDate = Date.now();

      if (expDate < currDate) {
        this.clearStorage();
        return false;
      }
    }
    if (isLocalHost()) {
      console.log('🍪:', token);
    }
    return token;
  },
  setRole(roleId) {
    return this.set('roleId', roleId);
  },
  setUser(userObj) {
    if (userObj) {
      this.set('user', JSON.stringify(userObj));
    } else {
      this.destroy('user');
    }
  },
  getUser() {
    let user = this.get('user');
    if (user) {
      return JSON.parse(user);
    }
    let token = this.getToken();
    if (token) {
      user = jwtDecode(token);
      if (user) {
        return user;
      }
    }
    return null;
  },
  getApiConfig(params, originalToken) {
    let h = {
      'headers': {
        'pragma': 'no-cache'
      }
    };
    if (params) {
      Object.keys(params).map((key) => {
        h[key] = params[key];
        return null;
      });
    }
    let token = this.getToken();
    if (token) {
      h.headers = {
        ...h.headers,
        'Authorization': 'Bearer ' + this.getToken(originalToken),
      }
    }

    return h;
  },
  getId() {
    let id = localStorage.getItem("id");
    if (!id) {
      id = this.generateId();
    }
    return id;
  },
  getStoragePrefixes(key) {
    let id = this.getId();
    return id + this.renderer + this.client + key;
  },
  generateId() {
    var id = makeid();
    localStorage.setItem("id", id);
    return id;
  },
  getSsoLink(ssoId) {
    let id = ssoId ? ssoId : makeid();
    let returnUrl = this.api.csodOssoEnpoint + "&ticket=" + id + "&returnurl=" + encodeURIComponent(this.frontURL);
    return returnUrl;
    //return this.api.endpoint + 'api/UserSso/sso/' + id + "?returnUrl=" + encodeURI(window.location.href);
  },
  getSsoId() {
    return this.get('ssoId');
  },
  setSsoId(ssoId) {
    this.set('ssoId', ssoId);
  },
  getBaseBreadCrumbUrl() {
    return (process.env.API_ENDPOINT.indexOf("localhost") > -1) ? "/leader-board" : "/catalog/CustomPage.aspx?id=221000324";
  }
};



// WEBPACK FOOTER //
// ./src/config/index.js